<template>
        <!-- footer -->
    <footer class="footer">
        <div class="container">
            <div class="row justify-content-between">
                <div class="col-lg-4">
                    <div class="intro">
                        <!-- <img src="images/logo.svg" alt="logo-image" class="logo"> -->
                        <h3>Brand</h3>
                        <p>It is a long established fact that a reader will be distracted by the readable content of a
                            page when
                            looking at its layout.</p>
                        <ul class="list-unstyled d-flex align-items-center social-icons">
                            <li><a href="#" class="facebook"><i class="fab fa-facebook-f"></i></a></li>
                            <li><a href="#" class="twitter"><i class="fab fa-twitter"></i></a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-7">
                    <div class="content">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="links">
                                    <h5>Useful Links</h5>
                                    <ul class="list-unstyled">
                                        <li><a href="#">How it works</a></li>
                                        <li><a href="#">About us</a></li>
                                        <li><a href="#">Babysitters</a></li>
                                        <li><a href="#">Contact us</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="links">
                                    <h5>My Account</h5>
                                    <ul class="list-unstyled">
                                        <li><a href="#">Track my order</a></li>
                                        <li><a href="#">Terms of use</a></li>
                                        <li><a href="#">Wishlist</a></li>
                                        <li><a href="#">Submit Your feedbac</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="links">
                                    <h5>Customer Service</h5>
                                    <ul class="list-unstyled">
                                        <li><a href="#">Help & Contact Us</a></li>
                                        <li><a href="#">Returns & Refunds</a></li>
                                        <li><a href="#">Online Stores</a></li>
                                        <li><a href="#">Terms & Condition</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="copyright text-center">
                        <p>All rights reserved for Kidstore 2018</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- end footer -->
</template>

<script>
export default {
    
}
</script>